class CategoryHero extends HTMLElement {
  constructor() {
    super();
    this.descriptionContent = this.querySelector('.category-hero__description-content');
    this.readMoreBtn = this.querySelector('.category-hero__read-more-btn');

    if (!this.descriptionContent || !this.readMoreBtn) return;

    this.isExpanded = false;
    this.originalHTML = this.descriptionContent.innerHTML;

    // Bind events
    this.readMoreBtn.addEventListener('click', this.toggleContent.bind(this));

    // Initial setup
    this.handleResize();
    window.addEventListener('resize', this.debounce(this.handleResize.bind(this), 250));
  }
  
  handleResize() {
    const isMobile = window.innerWidth < 769;
    const wordLimit = isMobile ? 25 : 42;
    
    if (!this.isExpanded) {
      this.truncateContent(wordLimit);
    }
  }
  
  truncateContent(wordLimit) {
    // A simple approximation for word count with HTML preservation
    // For robust HTML truncation, we use CSS line-clamp in CSS, 
    // but here we toggle the class that applies the line-clamp.
    // CSS line-clamp is much safer for rich text than JS string manipulation.
    
    this.descriptionContent.classList.add('is-truncated');
    this.readMoreBtn.innerHTML = 'READ MORE &rsaquo;';
    
    // Check if content actually needs truncation
    this.checkIfNeedsTruncation();
  }
  
  expandContent() {
    this.descriptionContent.classList.remove('is-truncated');
    this.readMoreBtn.innerHTML = 'READ LESS &rsaquo;';
    this.readMoreBtn.style.display = 'inline-flex';
  }
  
  checkIfNeedsTruncation() {
    // Check if content is actually being truncated
    // If scrollHeight > clientHeight, content is truncated
    if (this.descriptionContent.scrollHeight > this.descriptionContent.clientHeight) {
      this.readMoreBtn.style.display = 'inline-flex';
    } else {
      this.readMoreBtn.style.display = 'none';
    }
  }
  
  toggleContent() {
    this.isExpanded = !this.isExpanded;
    
    if (this.isExpanded) {
      this.expandContent();
    } else {
      const isMobile = window.innerWidth < 769;
      const wordLimit = isMobile ? 25 : 42;
      this.truncateContent(wordLimit);
    }
  }
  
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('category-hero', CategoryHero);
